import { API_URL, customer_support } from "../../../../utils/config";

export const GET_EMPLOYEES_IN_CUSTOMER_SUPPORT_URL = `${API_URL}/qa/department/${customer_support}`;
export const SCORE_AGENT_URL = `${API_URL}/qa`;
export const GET_AGENT_SCORE_URL = `${API_URL}/qa/getstaff`;
export const SEARCH_REPORT_BY_DATE_URL = `${API_URL}/qa/searchReportByDateCreated`;